import React, {useEffect} from "react";
import "./style.css";
import {formatCheeseName} from "../../../../../utils/common";
import { getCaloUserCountLabel } from "../../../../../const/SocialProof";

import { Image } from "../../../../../components/Image";
export const MobileUserPower = ({
    clickNext = () => {},
    clickPrev = () => {},
    data,
    clicked
                            }) => {
  return (
    <div className="user-power-mobile" data-model-id="16761:2588">
      <div className="div">
        <div className="title">
          <p className="heading">Calo was made for people just like you!</p>
        </div>

        <div className="photo-wall">
          <Image src={`/static/image/questionnaire/fasting/userPower/UserPower${formatCheeseName(data.gender)}.png`} alt="Photo wall f" className="photo-wall-f" />

          <div className="user-count">{getCaloUserCountLabel()}</div>
        </div>

        <div className="user-feedback">
          <p className="feedback-title">
            <span className="text-wrapper">87%</span>

            <span className="span"> of Calo users</span>
          </p>

          <p className="feedback-description">
            report that Calo has helped them achieve long-lasting health
            results. This data comes from users&#39; feedback
          </p>
        </div>
      </div>
    </div>
  );
};
